module.exports = __webpack_public_path__ + "static/img/8.5ed62ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/8.png
// module id = zWPf
// module chunks = 0